/* eslint-disable @typescript-eslint/naming-convention */
import useFunderOrgConfig from 'Hooks/useFunderOrgConfig/useFunderOrgConfig'
import useNonprofitOrgConfig from 'Hooks/useNonprofitOrgConfig/useNonprofitOrgConfig'
import useFeatureGatingConfig from 'Hooks/useFeatureGatingLimit/useFeatureGatingConfig'
import useDonationDetails from 'Hooks/useDonations/useDonationDetails'
import useUserConfig from 'Hooks/useUserConfig/useUserConfig'
import { ComponentType, FC } from 'react'
import useCloudinaryConfig from 'Hooks/useCloudinary/useCloudinaryConfig'
import useFeatureFlagsLoader from 'Hooks/useFeatureFlagsLoader/useFeatureFlagsLoader'
import useCampaigns from 'Hooks/useCampaigns/useCampaigns'

// eslint-disable-next-line @typescript-eslint/ban-types
const WithOrgConfig = <P extends object>(
  ComponentToValidate: ComponentType<P>
): FC<P> => {
  const WithOrgConfigComponent = (componentProps: P): JSX.Element => {
    // batching these

    useNonprofitOrgConfig()
    useDonationDetails()
    useCampaigns()
    useFunderOrgConfig()
    useUserConfig()
    useFeatureGatingConfig()
    useCloudinaryConfig()
    useFeatureFlagsLoader()

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <ComponentToValidate {...(componentProps as P)} />
  }
  return WithOrgConfigComponent
}
export default WithOrgConfig
